import axios from 'axios'
import { readCookie } from './cookie'

/**
 * Requests a URL, returning a promise
 *
 * @param  {object} config - The options we want to pass to "fetch". At minimum needs an `url` property
 */
export default async function request (config = {}) {
  if (!config.url) throw Error('utils/request requires at least a { url } config property')
  let { data } = await axios.request({
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRFToken': readCookie('csrftoken')
    },
    mode: 'cors',
    withCredentials: false,
    ...config
  })

  if (data.error) {
    throw Error(`Request responded with an error: ${data.error}`)
  }

  return data
}
